import { useState, useEffect } from 'react';

export default function CampaignSection() {
  const [timeLeft, setTimeLeft] = useState({
    days: 18,
    hours: 14,
    minutes: 28,
    seconds: 52
  });

  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return { ...prev, seconds: prev.seconds - 1 };
        } else if (prev.minutes > 0) {
          return { ...prev, minutes: prev.minutes - 1, seconds: 59 };
        } else if (prev.hours > 0) {
          return { ...prev, hours: prev.hours - 1, minutes: 59, seconds: 59 };
        } else if (prev.days > 0) {
          return { ...prev, days: prev.days - 1, hours: 23, minutes: 59, seconds: 59 };
        }
        return prev;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const campaigns = [
    {
      name: '三井住友カード（NL）',
      image: 'https://public.readdy.ai/ai/img_res/38ff9ca7990c2455185551ac5ac942af.jpg',
      bonus: '最大25,600円相当',
      conditions: [
        '新規入会＆利用でVポイントプレゼント',
        'スマホのタッチ決済利用で最大25,600円相当プレゼント'
      ],
      deadline: '終了日未定',
      url: '/mitsui',
      highlight: true,
      badge: '🔥 最高額',
      badgeColor: 'from-red-500 to-orange-500'
    },
    {
      name: '大手ECモール系カード',
      image: 'https://readdy.ai/api/search-image?query=rakuten%20credit%20card%20campaign%20banner%20with%20vibrant%20red%20and%20white%20colors%20showing%20point%20bonus%20promotion%20with%20modern%20energetic%20design%20featuring%20gift%20icons%20and%20celebration%20elements%20on%20clean%20background&width=400&height=250&seq=rakutencampaign001&orientation=landscape',
      bonus: '5,000ポイント',
      conditions: [
        '新規入会で2,000ポイント',
        'カード初回利用で3,000ポイント'
      ],
      deadline: '終了日未定',
      url: '/rakuten',
      highlight: false,
      badge: '⚡ 人気No.1',
      badgeColor: 'from-yellow-500 to-amber-500'
    },
    {
      name: 'リクルートカード',
      image: 'https://readdy.ai/api/search-image?query=recruit%20credit%20card%20campaign%20banner%20with%20energetic%20orange%20and%20red%20colors%20showing%20cashback%20promotion%20with%20dynamic%20modern%20design%20featuring%20money%20and%20reward%20icons%20on%20clean%20white%20background&width=400&height=250&seq=recruitcampaign001&orientation=landscape',
      bonus: '最大6,000円相当',
      conditions: [
        '新規入会で1,000円相当',
        '初回利用で2,000円相当',
        '携帯料金支払いで3,000円相当'
      ],
      deadline: '終了日未定',
      url: '/recruit',
      highlight: false,
      badge: '✨ 高還元',
      badgeColor: 'from-purple-500 to-pink-500'
    }
  ];

  return (
    <section className="py-16 bg-gradient-to-b from-gray-900 via-gray-800 to-gray-50 relative overflow-hidden">
      {/* 背景装飾 */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-gradient-to-br from-yellow-500 to-orange-500 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-gradient-to-tr from-teal-500 to-emerald-500 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="relative max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-gradient-to-r from-yellow-500 via-orange-500 to-red-500 text-white text-sm font-bold px-6 py-3 rounded-full shadow-2xl shadow-orange-500/50 mb-6 animate-bounce">
            <i className="ri-fire-fill text-xl"></i>
            期間限定
            <i className="ri-fire-fill text-xl"></i>
          </div>
          
          <h3 className="text-3xl sm:text-4xl font-bold mb-6 text-white">
            今月のおすすめキャンペーン情報
          </h3>

          {/* カウントダウンタイマー */}
          <div className="inline-block bg-gradient-to-r from-gray-800 to-gray-700 rounded-2xl p-6 shadow-2xl border border-gray-600 mb-6">
            <div className="text-yellow-400 text-sm font-bold mb-3 flex items-center justify-center gap-2">
              <i className="ri-time-line text-lg"></i>
              キャンペーン終了まで
            </div>
            <div className="flex gap-3 sm:gap-4">
              <div className="text-center">
                <div className="bg-gradient-to-br from-red-500 to-orange-500 text-white text-2xl sm:text-3xl font-bold w-14 sm:w-16 h-14 sm:h-16 rounded-xl flex items-center justify-center shadow-lg">
                  {timeLeft.days}
                </div>
                <div className="text-gray-400 text-xs mt-2">日</div>
              </div>
              <div className="text-white text-2xl sm:text-3xl font-bold flex items-center">:</div>
              <div className="text-center">
                <div className="bg-gradient-to-br from-orange-500 to-yellow-500 text-white text-2xl sm:text-3xl font-bold w-14 sm:w-16 h-14 sm:h-16 rounded-xl flex items-center justify-center shadow-lg">
                  {timeLeft.hours}
                </div>
                <div className="text-gray-400 text-xs mt-2">時間</div>
              </div>
              <div className="text-white text-2xl sm:text-3xl font-bold flex items-center">:</div>
              <div className="text-center">
                <div className="bg-gradient-to-br from-yellow-500 to-green-500 text-white text-2xl sm:text-3xl font-bold w-14 sm:w-16 h-14 sm:h-16 rounded-xl flex items-center justify-center shadow-lg">
                  {timeLeft.minutes}
                </div>
                <div className="text-gray-400 text-xs mt-2">分</div>
              </div>
              <div className="text-white text-2xl sm:text-3xl font-bold flex items-center">:</div>
              <div className="text-center">
                <div className="bg-gradient-to-br from-green-500 to-teal-500 text-white text-2xl sm:text-3xl font-bold w-14 sm:w-16 h-14 sm:h-16 rounded-xl flex items-center justify-center shadow-lg animate-pulse">
                  {timeLeft.seconds}
                </div>
                <div className="text-gray-400 text-xs mt-2">秒</div>
              </div>
            </div>
          </div>

          <p className="text-gray-300">
            今なら入会特典で最大25,600円相当がもらえるチャンス！<br />
            終了日未定のため、お早めのお申込みがおすすめです。
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          {campaigns.map((campaign, index) => (
            <div
              key={index}
              className={`group relative bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-500 hover:-translate-y-2 ${
                campaign.highlight ? 'ring-4 ring-[#FFB800]' : ''
              }`}
            >
              {/* バッジ */}
              <div className={`absolute top-4 right-4 bg-gradient-to-r ${campaign.badgeColor} text-white text-xs font-bold px-3 py-1.5 rounded-full shadow-lg z-10 animate-pulse`}>
                {campaign.badge}
              </div>

              {campaign.highlight && (
                <div className="bg-gradient-to-r from-[#FFB800] to-[#FFA000] text-white text-center py-2 font-bold text-sm">
                  ⭐ 最もお得なキャンペーン
                </div>
              )}
              
              <div className="w-full h-48 bg-gray-100 overflow-hidden">
                <img
                  src={campaign.image}
                  alt={`${campaign.name}キャンペーン`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
              </div>

              <div className="p-6">
                <h4 className="text-xl font-bold text-[#003366] mb-3">{campaign.name}</h4>
                
                <div className="bg-yellow-50 border-2 border-[#FFB800] rounded-lg p-4 mb-4">
                  <div className="text-sm text-gray-600 mb-1">入会特典</div>
                  <div className="text-2xl font-bold text-[#FFB800]">{campaign.bonus}</div>
                </div>

                <div className="mb-4">
                  <div className="text-sm font-bold text-gray-700 mb-2">特典内容</div>
                  <ul className="space-y-2">
                    {campaign.conditions.map((condition, idx) => (
                      <li key={idx} className="flex items-start gap-2 text-sm text-gray-700">
                        <i className="ri-check-line text-[#14B8A6] text-lg flex-shrink-0 w-5 h-5 flex items-center justify-center"></i>
                        <span>{condition}</span>
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="text-xs text-gray-500 mb-4 flex items-center gap-1">
                  <i className="ri-time-line w-4 h-4 flex items-center justify-center"></i> {campaign.deadline}
                </div>

                <a
                  href={campaign.url}
                  className="block w-full bg-gradient-to-r from-[#003366] to-[#004488] text-white text-center px-6 py-3 rounded-lg font-bold hover:from-[#004488] hover:to-[#0055AA] transition-all cursor-pointer whitespace-nowrap shadow-lg group-hover:shadow-xl"
                >
                  詳細を見る
                </a>
              </div>

              {/* キラキラエフェクト */}
              <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-full h-full opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none">
                <div className="absolute top-1/4 left-1/4 w-2 h-2 bg-yellow-400 rounded-full animate-ping"></div>
                <div className="absolute top-3/4 right-1/4 w-2 h-2 bg-yellow-400 rounded-full animate-ping" style={{ animationDelay: '0.5s' }}></div>
              </div>
            </div>
          ))}
        </div>

        <div className="bg-gradient-to-r from-[#003366] to-[#004488] rounded-xl p-8 text-white text-center shadow-2xl">
          <h4 className="text-2xl font-bold mb-4">
            キャンペーン適用の注意点
          </h4>
          <div className="grid md:grid-cols-3 gap-6 text-left">
            <div className="flex items-start gap-3">
              <i className="ri-information-line text-[#FFB800] text-2xl flex-shrink-0 w-6 h-6 flex items-center justify-center"></i>
              <div>
                <div className="font-bold mb-1">申込み期限</div>
                <div className="text-sm">キャンペーンは予告なく終了する場合があります</div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <i className="ri-checkbox-circle-line text-[#FFB800] text-2xl flex-shrink-0 w-6 h-6 flex items-center justify-center"></i>
              <div>
                <div className="font-bold mb-1">条件達成</div>
                <div className="text-sm">特典を受け取るには条件達成が必要です</div>
              </div>
            </div>
            <div className="flex items-start gap-3">
              <i className="ri-calendar-check-line text-[#FFB800] text-2xl flex-shrink-0 w-6 h-6 flex items-center justify-center"></i>
              <div>
                <div className="font-bold mb-1">付与時期</div>
                <div className="text-sm">ポイント付与は条件達成後1〜3ヶ月程度</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
